import React, { useEffect } from 'react';
import './App.css';
import './components/Common/Pagination/Pagination.css';
import './components/Common/Table/Table.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import Login from './pages/Auth/Login';
import ForgotPassword from './pages/Auth/ForgotPassword';
import VerifyCode from './pages/Auth/VerifyCode';
import ResetPassword from './pages/Auth/ResetPassword';
import Dashboard from './pages/Dashboard/Dashboard';
import Profile from './pages/Profile/Profile';
import Projects from './pages/Projects/Projects';
import ProjectView from './pages/Projects/ProjectView';
import CreateProject from './pages/Projects/CreateProject';
import EditProject from './pages/Projects/EditProject';
import WorkOrders from './pages/Projects/WorkOrders';
import LOIs from './pages/LOI/LOIs';
import CreateLOI from './pages/LOI/CreateLOI';
import EditLOI from './pages/LOI/EditLOI';
import ViewLOI from './pages/LOI/ViewLOI';
import DesignSubmissions from './pages/Projects/DesignSubmissions';
import UploadDesign from './pages/Projects/UploadDesign';
import EditDesignSubmission from './pages/Projects/EditDesignSubmission';
import DesignReview from './pages/Projects/DesignReview';
import DesignApproval from './pages/Projects/DesignApproval';
import PurchaseOrders from './pages/PurchaseOrder/PurchaseOrders';
import CreatePO from './pages/PurchaseOrder/CreatePO';
import EditPO from './pages/PurchaseOrder/EditPO';
import ViewPO from './pages/PurchaseOrder/ViewPO';
import Vendors from './pages/Vendors/Vendors.jsx';
import ViewVendor from './pages/Vendors/ViewVendor';
import Customers from './pages/Customers/Customers';
import ViewCustomer from './pages/Customers/ViewCustomer';
import ViewUnit from './pages/Inventory/Units/ViewUnit';
import ViewTax from './pages/Finance/Taxes/ViewTax';
import ViewProjectType from './pages/Projects/ProjectType/ViewProjectType';
import ViewBank from './pages/Finance/Banks/ViewBank';
import Employees from './pages/Employees/Employees';
import Departments from './pages/Employees/Departments';
import Designations from './pages/Employees/Designations';
import ViewUser from './pages/Users/ViewUser';
import ViewEmployee from './pages/Employees/ViewEmployee';
import ViewDepartment from './pages/Employees/ViewDepartment';
import ViewDesignation from './pages/Employees/ViewDesignation';
import AddEmployee from './pages/Employees/AddEmployee';
import EditEmployee from './pages/Employees/EditEmployee';
import EmployeeAttendanceView from './pages/Employees/AttendanceView/EmployeeAttendanceView';
import VendorPayments from './pages/Finance/VendorPayments';
import ViewVendorPayment from './pages/Finance/ViewVendorPayment';
import InspectionTracking from './pages/Inspections/InspectionTracking';
import ScheduleInspection from './pages/Inspections/ScheduleInspection';
import InspectionClearance from './pages/Inspections/InspectionClearance';
import ViewInspection from './pages/Inspections/ViewInspection';
import Users from './pages/Users/Users';
import UserPermissions from './pages/Users/UserPermissions';
import MaterialReceipts from './pages/Inventory/MaterialReceipts';
import AddMaterialReceipt from './pages/Inventory/AddMaterialReceipt';
import EditMaterialReceipt from './pages/Inventory/EditMaterialReceipt';
import ViewMaterialReceipt from './pages/Inventory/ViewMaterialReceipt';
import PaymentsReceived from './pages/Finance/PaymentsReceived';
import ViewPaymentReceived from './pages/Finance/ViewPaymentReceived';
import AddPaymentReceived from './pages/Finance/AddPaymentReceived';
import EditPaymentReceived from './pages/Finance/EditPaymentReceived';
import Units from './pages/Inventory/Units/Units';
import Taxes from './pages/Finance/Taxes/Taxes';
import ProjectType from './pages/Projects/ProjectType/ProjectType';
import Invoices from './pages/Finance/Invoices/Invoices';
import CreateInvoice from './pages/Finance/Invoices/CreateInvoice';
import EditInvoice from './pages/Finance/Invoices/EditInvoice';
import ViewInvoice from './pages/Finance/Invoices/ViewInvoice';
import Banks from './pages/Finance/Banks/Banks';
import Holidays from './pages/Masters/Holidays/Holidays';
import LeaveTypes from './pages/Masters/LeaveTypes/LeaveTypes';
import Attendance from './pages/Employees/Attendance/Attendance';
import ViewAttendance from './pages/Employees/Attendance/ViewAttendance';

import OTAssignments from './pages/Employees/Overtime/OTAssignments';
import OTRequests from './pages/Employees/Overtime/OTRequests';
import EmployeeOT from './pages/Employees/Overtime/EmployeeOT';
import OTAttendance from './pages/Employees/Overtime/OTAttendance';
import ViewOTAttendance from './pages/Employees/Overtime/ViewOTAttendance';
import ViewOTAssignment from './pages/Employees/Overtime/ViewOTAssignment';
import AdvanceRequests from './pages/Employees/AdvanceRequests/AdvanceRequests';
import ViewAdvanceRequest from './pages/Employees/AdvanceRequests/ViewAdvanceRequest';
import Loans from './pages/Employees/Loans/Loans';
import ViewLoan from './pages/Employees/Loans/ViewLoan';
import Expenses from './pages/Finance/Expenses';
import ViewExpense from './pages/Finance/ViewExpense';
import ExpenseCategories from './pages/Finance/ExpenseCategories';
import WorkOrderView from './pages/Projects/WorkOrderView';
import Tasks from './pages/Tasks/Tasks';
import CreateTask from './pages/Tasks/CreateTask';
import EditTask from './pages/Tasks/EditTask';
import ViewTask from './pages/Tasks/ViewTask';
import ManufacturerClearance from './pages/ManufacturerClearance/ManufacturerClearance';
import AddManufacturerClearance from './pages/ManufacturerClearance/AddManufacturerClearance';
import EditManufacturerClearance from './pages/ManufacturerClearance/EditManufacturerClearance';
import ViewManufacturerClearance from './pages/ManufacturerClearance/ViewManufacturerClearance';
import LeaveRequests from './pages/Employees/LeaveRequests';
import ViewLeaveRequest from './pages/Employees/ViewLeaveRequest';
import EmployeeDashboard from './pages/Employees/Dashboard/EmployeeDashboard';
import MyAttendance from './pages/Employees/Dashboard/MyAttendance';
import AttendanceSettings from './pages/Employees/AttendanceSettings/AttendanceSettings';
import HRDashboard from './pages/Employees/HRDashboard/HRDashboard';
import MonthlyReportList from './pages/Employees/MonthlyReport/MonthlyReportList';
import MonthlyReportView from './pages/Employees/MonthlyReport/MonthlyReportView';
// ... (rest of imports)
import ProtectedRoute from './components/Auth/ProtectedRoute';
import PublicRoute from './components/Auth/PublicRoute';
import { SidebarProvider } from './context/SidebarContext';
import { LoadingProvider } from './context/LoadingContext';
import ScrollToTopButton from './components/Common/ScrollToTopButton/ScrollToTopButton';
import ScrollToTop from './components/Common/ScrollToTop/ScrollToTop';
import NotFound from './pages/Error/NotFound';
import { Navigate } from 'react-router-dom';
import { startBackgroundLocationTracking } from './utils/locationService';

const RootDashboard = () => {
  const userData = localStorage.getItem('user');
  if (!userData) {
    return <Navigate to="/login" replace />;
  }
  const user = JSON.parse(userData);
  const isAdmin = (user.role || '').toLowerCase() === 'admin';

  return isAdmin ? <Dashboard /> : <Navigate to="/employees/dashboard" replace />;
};

function App() {
  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      const user = JSON.parse(userData);
      startBackgroundLocationTracking();
    }
  }, []);

  return (
    <Router>
      <LoadingProvider>
        <SidebarProvider>
          <ScrollToTop />
          <Routes>
            {/* Public Routes */}
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
            <Route path="/verify-code" element={<PublicRoute><VerifyCode /></PublicRoute>} />
            <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />

            {/* Protected Routes */}
            <Route path="/projects" element={<ProtectedRoute permission="view projects"><Projects /></ProtectedRoute>} />
            <Route path="/projects/create" element={<ProtectedRoute permission="create projects"><CreateProject /></ProtectedRoute>} />
            <Route path="/projects/edit/:id" element={<ProtectedRoute permission="edit projects"><EditProject /></ProtectedRoute>} />
            <Route path="/projects/:id" element={<ProtectedRoute permission="view projects"><ProjectView /></ProtectedRoute>} />
            <Route path="/projects/:id/work-orders" element={<ProtectedRoute permission="view work orders"><WorkOrders /></ProtectedRoute>} />
            <Route path="/projects/work-orders/:id" element={<ProtectedRoute permission="view work orders"><WorkOrderView /></ProtectedRoute>} />
            <Route path="/projects/work-orders" element={<ProtectedRoute permission="view work orders"><WorkOrders /></ProtectedRoute>} />
            <Route path="/projects/lois" element={<ProtectedRoute permission="view projects"><LOIs /></ProtectedRoute>} />
            <Route path="/projects/lois/create" element={<ProtectedRoute permission="view projects"><CreateLOI /></ProtectedRoute>} />
            <Route path="/projects/lois/edit/:id" element={<ProtectedRoute permission="view projects"><EditLOI /></ProtectedRoute>} />
            <Route path="/projects/lois/:id" element={<ProtectedRoute permission="view projects"><ViewLOI /></ProtectedRoute>} />
            <Route path="/purchase-orders" element={<ProtectedRoute permission="view projects"><PurchaseOrders /></ProtectedRoute>} />
            <Route path="/purchase-orders/create" element={<ProtectedRoute permission="view projects"><CreatePO /></ProtectedRoute>} />
            <Route path="/purchase-orders/edit/:id" element={<ProtectedRoute permission="view projects"><EditPO /></ProtectedRoute>} />
            <Route path="/purchase-orders/:id" element={<ProtectedRoute permission="view projects"><ViewPO /></ProtectedRoute>} />
            <Route path="/projects/design-submissions" element={<ProtectedRoute permission="view designs"><DesignSubmissions /></ProtectedRoute>} />
            <Route path="/projects/design-submissions/upload" element={<ProtectedRoute permission="upload designs"><UploadDesign /></ProtectedRoute>} />
            <Route path="/projects/design-submissions/edit/:id" element={<ProtectedRoute permission="view designs"><EditDesignSubmission /></ProtectedRoute>} />
            <Route path="/projects/design-submissions/review/:id" element={<ProtectedRoute permission="review designs"><DesignReview /></ProtectedRoute>} />
            <Route path="/projects/design-approval/:id" element={<ProtectedRoute permission="approve designs"><DesignApproval /></ProtectedRoute>} />
            <Route path="/vendors" element={<ProtectedRoute permission="view vendors"><Vendors /></ProtectedRoute>} />

            {/* Tasks Routes */}
            <Route path="/tasks" element={<ProtectedRoute permission="view tasks"><Tasks /></ProtectedRoute>} />
            <Route path="/tasks/create" element={<ProtectedRoute permission="create tasks"><CreateTask /></ProtectedRoute>} />
            <Route path="/tasks/edit/:id" element={<ProtectedRoute permission="edit tasks"><EditTask /></ProtectedRoute>} />
            <Route path="/tasks/view/:id" element={<ProtectedRoute permission="view tasks"><ViewTask /></ProtectedRoute>} />
            <Route path="/vendors/view/:id" element={<ProtectedRoute permission="view vendors"><ViewVendor /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute permission="view customers"><Customers /></ProtectedRoute>} />
            <Route path="/customers/view/:id" element={<ProtectedRoute permission="view customers"><ViewCustomer /></ProtectedRoute>} />
            <Route path="/units/view/:id" element={<ProtectedRoute permission="view units"><ViewUnit /></ProtectedRoute>} />
            <Route path="/taxes/view/:id" element={<ProtectedRoute permission="view taxes"><ViewTax /></ProtectedRoute>} />
            <Route path="/project-types/view/:id" element={<ProtectedRoute permission="view project types"><ViewProjectType /></ProtectedRoute>} />
            <Route path="/banks/view/:id" element={<ProtectedRoute permission="view banks"><ViewBank /></ProtectedRoute>} />
            <Route path="/employees" element={<ProtectedRoute permission="view employees"><Employees /></ProtectedRoute>} />
            <Route path="/employees/dashboard" element={<ProtectedRoute permission="view dashboard"><EmployeeDashboard /></ProtectedRoute>} />
            <Route path="/employees/my-attendance" element={<ProtectedRoute permission={["view dashboard", "view attendance"]}><MyAttendance /></ProtectedRoute>} />
            <Route path="/employees/departments" element={<ProtectedRoute permission="view departments"><Departments /></ProtectedRoute>} />
            <Route path="/employees/departments/view/:id" element={<ProtectedRoute permission="view departments"><ViewDepartment /></ProtectedRoute>} />
            <Route path="/employees/designations" element={<ProtectedRoute permission="view designations"><Designations /></ProtectedRoute>} />
            <Route path="/employees/designations/view/:id" element={<ProtectedRoute permission="view designations"><ViewDesignation /></ProtectedRoute>} />
            <Route path="/employees/add" element={<ProtectedRoute permission="create employees"><AddEmployee /></ProtectedRoute>} />
            <Route path="/employees/edit/:id" element={<ProtectedRoute permission="edit employees"><EditEmployee /></ProtectedRoute>} />
            <Route path="/employees/view/:id" element={<ProtectedRoute permission="view employees"><ViewEmployee /></ProtectedRoute>} />
            <Route path="/employees/attendance/view/:id" element={<ProtectedRoute permission="view employees"><EmployeeAttendanceView /></ProtectedRoute>} />
            <Route path="/employees/leave-requests" element={<ProtectedRoute permission="view leave"><LeaveRequests /></ProtectedRoute>} />
            <Route path="/employees/leave-requests/view/:id" element={<ProtectedRoute permission="view leave"><ViewLeaveRequest /></ProtectedRoute>} />
            <Route path="/hr/dashboard" element={<ProtectedRoute permission="view dashboard"><HRDashboard /></ProtectedRoute>} />
            <Route path="/employees/attendance" element={<ProtectedRoute permission="view attendance"><Attendance /></ProtectedRoute>} />
            <Route path="/employees/attendance/session/:id" element={<ProtectedRoute permission="view attendance"><ViewAttendance /></ProtectedRoute>} />
            <Route path="/employees/attendance-settings" element={<ProtectedRoute permission="manage permissions"><AttendanceSettings /></ProtectedRoute>} />
            <Route path="/employees/monthly-report" element={<ProtectedRoute permission="view attendance"><MonthlyReportList /></ProtectedRoute>} />
            <Route path="/employees/monthly-report/view/:id" element={<ProtectedRoute permission="view attendance"><MonthlyReportView /></ProtectedRoute>} />

            <Route path="/employees/ot-assignments" element={<ProtectedRoute permission={["view ot assignments"]}><OTAssignments /></ProtectedRoute>} />
            <Route path="/employees/ot-assignments/view/:id" element={<ProtectedRoute permission={["view ot assignments"]}><ViewOTAssignment /></ProtectedRoute>} />
            <Route path="/employees/my-overtime" element={<ProtectedRoute permission={["view dashboard"]}><EmployeeOT /></ProtectedRoute>} />
            <Route path="/employees/ot-requests" element={<ProtectedRoute permission={["view ot requests"]}><OTAssignments defaultTab="requests" /></ProtectedRoute>} />
            <Route path="/employees/ot-attendance" element={<ProtectedRoute permission={["view ot attendance logs", "view ot attendance"]}><OTAttendance /></ProtectedRoute>} />
            <Route path="/employees/ot-attendance/view/:id" element={<ProtectedRoute permission={["view ot attendance logs", "view ot attendance"]}><ViewOTAttendance /></ProtectedRoute>} />
            <Route path="/employees/advance-requests" element={<ProtectedRoute permission="view advance requests"><AdvanceRequests /></ProtectedRoute>} />
            <Route path="/employees/advance-requests/view/:id" element={<ProtectedRoute permission="view advance requests"><ViewAdvanceRequest /></ProtectedRoute>} />
            <Route path="/employees/loan-requests" element={<ProtectedRoute permission="view loan requests"><Loans /></ProtectedRoute>} />
            <Route path="/employees/loan-requests/view/:id" element={<ProtectedRoute permission="view loan requests"><ViewLoan /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute permission="view users"><Users /></ProtectedRoute>} />
            <Route path="/users/view/:id" element={<ProtectedRoute permission="view users"><ViewUser /></ProtectedRoute>} />
            <Route path="/user-permissions" element={<ProtectedRoute permission="edit permissions"><UserPermissions /></ProtectedRoute>} />
            <Route path="/payment/vendor-payments" element={<ProtectedRoute permission="create vendor payments"><VendorPayments /></ProtectedRoute>} />
            <Route path="/payment/vendor-payments/:id" element={<ProtectedRoute permission="view vendor payments"><ViewVendorPayment /></ProtectedRoute>} />
            <Route path="/inspections" element={<ProtectedRoute permission="view inspections"><InspectionTracking /></ProtectedRoute>} />
            <Route path="/units" element={<ProtectedRoute permission="view inventory"><Units /></ProtectedRoute>} />
            <Route path="/taxes" element={<ProtectedRoute permission="view taxes"><Taxes /></ProtectedRoute>} />
            <Route path="/inspections/schedule" element={<ProtectedRoute permission="create inspections"><ScheduleInspection /></ProtectedRoute>} />
            <Route path="/inspections/edit/:id" element={<ProtectedRoute permission="edit inspections"><ScheduleInspection /></ProtectedRoute>} />
            <Route path="/inspections/clearance/:id" element={<ProtectedRoute permission="approve inspections"><InspectionClearance /></ProtectedRoute>} />
            <Route path="/inspections/:id" element={<ProtectedRoute permission="view inspections"><ViewInspection /></ProtectedRoute>} />
            <Route path="/manufacturer-clearance" element={<ProtectedRoute permission="view inspections"><ManufacturerClearance /></ProtectedRoute>} />
            <Route path="/manufacturer-clearance/add" element={<ProtectedRoute permission="create inspections"><AddManufacturerClearance /></ProtectedRoute>} />
            <Route path="/manufacturer-clearance/edit/:id" element={<ProtectedRoute permission="edit inspections"><EditManufacturerClearance /></ProtectedRoute>} />
            <Route path="/manufacturer-clearance/view/:id" element={<ProtectedRoute permission="view inspections"><ViewManufacturerClearance /></ProtectedRoute>} />
            <Route path="/receipts" element={<ProtectedRoute permission="view material receipts"><MaterialReceipts /></ProtectedRoute>} />
            <Route path="/receipts/add" element={<ProtectedRoute permission="create material receipts"><AddMaterialReceipt /></ProtectedRoute>} />
            <Route path="/receipts/edit/:id" element={<ProtectedRoute permission="edit material receipts"><EditMaterialReceipt /></ProtectedRoute>} />
            <Route path="/receipts/view/:id" element={<ProtectedRoute permission="view material receipts"><ViewMaterialReceipt /></ProtectedRoute>} />
            <Route path="/payment/payments-received" element={<ProtectedRoute permission="view payments received"><PaymentsReceived /></ProtectedRoute>} />
            <Route path="/payment/payments-received/view/:id" element={<ProtectedRoute permission="view payments received"><ViewPaymentReceived /></ProtectedRoute>} />
            <Route path="/payment/payments-received/add" element={<ProtectedRoute permission="create payments received"><AddPaymentReceived /></ProtectedRoute>} />
            <Route path="/payment/payments-received/edit/:id" element={<ProtectedRoute permission="edit payments received"><EditPaymentReceived /></ProtectedRoute>} />
            <Route path="/projects/invoices" element={<ProtectedRoute permission="view invoices"><Projects /></ProtectedRoute>} />
            <Route path="/projects/tasks" element={<ProtectedRoute permission="view tasks"><Projects /></ProtectedRoute>} />
            <Route path="/expenses" element={<ProtectedRoute permission="view expenses"><Expenses /></ProtectedRoute>} />
            <Route path="/expenses/view/:id" element={<ProtectedRoute permission="view expenses"><ViewExpense /></ProtectedRoute>} />
            <Route path="/finance/expense-categories" element={<ProtectedRoute permission="view expense categories"><ExpenseCategories /></ProtectedRoute>} />
            <Route path="/projects/expenses" element={<ProtectedRoute permission="view expenses"><Projects /></ProtectedRoute>} />
            <Route path="/project-types" element={<ProtectedRoute permission="view project types"><ProjectType /></ProtectedRoute>} />
            <Route path="/invoices" element={<ProtectedRoute permission="view sales invoices"><Invoices /></ProtectedRoute>} />
            <Route path="/invoices/add" element={<ProtectedRoute permission="create sales invoices"><CreateInvoice /></ProtectedRoute>} />
            <Route path="/invoices/edit/:id" element={<ProtectedRoute permission="edit sales invoices"><EditInvoice /></ProtectedRoute>} />
            <Route path="/invoices/view/:id" element={<ProtectedRoute permission="view sales invoices"><ViewInvoice /></ProtectedRoute>} />
            <Route path="/banks" element={<ProtectedRoute permission="view finance"><Banks /></ProtectedRoute>} />
            <Route path="/holidays" element={<ProtectedRoute permission="view holidays"><Holidays /></ProtectedRoute>} />
            <Route path="/leave-types" element={<ProtectedRoute permission="view leave types"><LeaveTypes /></ProtectedRoute>} />
            <Route path="/profile" element={<ProtectedRoute permission="view profile"><Profile /></ProtectedRoute>} />
            <Route path="/" element={<ProtectedRoute permission="view dashboard"><RootDashboard /></ProtectedRoute>} />
            {/* Catch-all Route for 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Toaster
            position="top-right"
            reverseOrder={false}
            containerStyle={{ zIndex: 99999 }}
            toastOptions={{
              style: {
                fontFamily: "'Outfit', sans-serif",
                borderRadius: '20px',
                background: '#1e293b',
                color: '#ffffff',
                boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.5)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                padding: '16px 24px',
                fontSize: '15px',
                fontWeight: '600',
                letterSpacing: '0.01em',
                maxWidth: '450px',
              },
              success: {
                duration: 4000,
                iconTheme: {
                  primary: '#10b981',
                  secondary: '#1e293b',
                },
                style: {
                  background: 'linear-gradient(135deg, #1e293b 0%, #064e3b 100%)',
                  borderLeft: '6px solid #10b981',
                }
              },
              error: {
                duration: 5000,
                iconTheme: {
                  primary: '#ef4444',
                  secondary: '#ffffff',
                },
                style: {
                  background: 'linear-gradient(135deg, #1e293b 0%, #450a0a 100%)',
                  borderLeft: '6px solid #ef4444',
                }
              },
              loading: {
                iconTheme: {
                  primary: '#fb923c',
                  secondary: '#ffffff',
                },
                style: {
                  background: '#1e293b',
                }
              }
            }}
          />
          <ScrollToTopButton />
        </SidebarProvider>
      </LoadingProvider>
    </Router>
  );
}

export default App;
